import React from 'react'

const Manual_inventario_recetas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Inventario - Recetas
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        Esta guía explica cómo gestionar recetas en el sistema de inventario, permitiendo un seguimiento y edición eficiente de ingredientes. Destaca la importancia de la conversión de unidades para mayor precisión y ayuda a optimizar el flujo de trabajo en la gestión culinaria.
      </p>
      <iframe
        src="https://scribehow.com/embed/Inventario__Recetas__MZC2WDCASzid4HexLglczg?as=scrollable"
        className="scribe-iframe-general-36"
        width="100%"
        height="4550"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_inventario_recetas